module.exports = __webpack_public_path__ + "img/knqun.com.fd2e3678.jpg";